import { TEMPLATE_ITEM_TYPE } from "@/consts/template";
import insertArrayAt from "@/utils/insertArrayAt";
import { v4 as uuidv4 } from "uuid";
import * as types from "./mutationTypes";

export default {
  [types.SET_TEMPLATES](state, templates) {
    state.templates = templates;
  },
  [types.CLEAR_TEMPLATES](state) {
    state.templates = null;
  },
  [types.SET_TOTAL_TEMPLATES](state, total) {
    state.totalTemplates = total;
  },
  [types.CLEAR_TOTAL_TEMPLATES](state) {
    state.totalTemplates = null;
  },
  [types.SET_TEMPLATE](state, template) {
    state.template = { ...template };
  },
  [types.CLEAR_TEMPLATE](state) {
    state.template = null;
  },
  [types.SET_NAME](state, value) {
    state.template.name = value;
  },
  [types.SET_TYPE](state, value) {
    state.template.type = value;
  },
  [types.SET_LANGUAGE](state, value) {
    state.template.languages = value;
  },
  [types.SET_DEFAULT](state, value) {
    state.template.is_default = value;
  },
  [types.ADD_ITEM](state, item) {
    const position = getInsertPosition(state.template.items, item.item_type);
    state.template.items.splice(position, 0, item);
  },
  [types.REMOVE_ITEM](state, itemIndex) {
    state.template.items = state.template.items.filter((i, index) => index !== itemIndex);
  },
  [types.CLEAR_ITEMS](state) {
    state.template.items = [];
  },
  [types.CLEAR_ITEMS_BY_LANGUAGE](state, language) {
    state.template.items = state.template.items.filter((item) => item.language !== language);
  },
  [types.SET_SELECTED_ITEM_INDEX](state, index) {
    state.selectedItemIndex = index;
  },
  [types.CLEAR_SELECTED_ITEM_INDEX](state) {
    state.selectedItemIndex = null;
  },
  [types.SET_CURRENT_LANGUAGE](state, value) {
    state.selectedLanguage = value;
  },
  [types.CLEAR_CURRENT_LANGUAGE](state) {
    state.selectedLanguage = null;
  },
  [types.UPDATE_ITEM](state, { itemIndex, field, value }) {
    state.template.items[itemIndex][field] = value;
  },
  [types.DUPLICATE_ITEM](state, itemIndex) {
    let itemCopy = { ...state.template.items[itemIndex] };
    delete itemCopy.uuid;
    itemCopy.uuid = uuidv4();
    state.template.items = insertArrayAt(state.template.items, itemCopy, itemIndex);
  }
};

const getInsertPosition = function (currentItems, itemType) {
  if (itemType === TEMPLATE_ITEM_TYPE.SENDER) {
    return 0;
  }
  if (itemType === TEMPLATE_ITEM_TYPE.SIGNATURE) {
    return currentItems.length;
  }
  const signs = currentItems.filter((i) => i.item_type === TEMPLATE_ITEM_TYPE.SIGNATURE);
  return currentItems.length - signs.length;
};
